import { blue20opacity15, blue60 } from '../../../colors/blue';
import { gray80 } from '../../../colors/gray';
import { neutral60opacity10 } from '../../../colors/neutral';
import { rem } from '../../../utils/rem';
export var MuiTab = {
    styleOverrides: {
        root: {
            fontWeight: 400,
            minHeight: rem(36),
            minWidth: rem(32),
            padding: 0,
            '&:last-of-type': { marginInlineEnd: 0 },
            '&:hover': {
                boxShadow: "inset 0 -3px 0 ".concat(neutral60opacity10),
            },
            '&[class*=Mui-selected]': {
                boxShadow: "inset 0 -3px 0 ".concat(blue60),
                fontWeight: '600',
            },
            '&[class*=Mui-focusVisible]': {
                alignSelf: 'center',
                borderRadius: rem(5),
                boxShadow: "0 0 0 2px ".concat(blue60),
                minHeight: rem(32),
            },
            '&[class*=MuiTab-overflow][class*=Mui-selected]': {
                backgroundColor: blue20opacity15,
            },
            '&[class*=MuiTab-overflow] .YdsSvgIcon-root': {
                marginInlineEnd: 0,
                pointerEvents: 'none',
            },
            '@media(min-width: 600px)': {
                minWidth: rem(32),
            },
        },
        textColorSecondary: {
            '&[class*=Mui-selected]': {
                color: gray80,
            },
        },
        labelIcon: {
            flexDirection: 'row',
            minHeight: rem(36),
            paddingTop: 0,
            '& > *:first-of-type': {
                marginBottom: 0,
            },
            '& [class*=MuiButton-root]': {
                borderRadius: '50%',
                color: 'inherit',
                height: rem(24),
                minWidth: rem(24),
                width: rem(24),
            },
        },
    },
    customOverrides: {
        startIcon: {
            '& > .YdsSvgIcon-root': {
                marginInlineEnd: rem(4),
            },
        },
        endIcon: {
            flexDirection: 'row-reverse',
            '& > .YdsSvgIcon-root': {
                marginInlineStart: rem(8),
            },
        },
    },
};
